import React, { useEffect } from "react";
import useChannelInfo from "../../hooks/useChannelInfo.js";
import useMessages from "../../hooks/useMessages.js";
import EBSMessage from "../EBSMessage/EBSMessage.js";
import Stack from "../Stack/Stack.js";

import "./OverlayMessagesContainer.scss";

const OverlayMessagesContainer = () => {
  const { messages, startPollingForMessages, dismissMessage } =
    useMessages("videoOverlay");
  const channelData = useChannelInfo();

  useEffect(() => {
    if (channelData?.message_polling_interval) {
      startPollingForMessages(channelData.message_polling_interval);
    }
  }, [channelData]);

  return (
    <Stack vertical spacing="small" className="overlay-messages-container">
      {messages.map((message, index) => (
        <EBSMessage
          key={message.id}
          type={message.type}
          content={message.content[channelData?.language] || message.content.en}
          onDismiss={() => dismissMessage(message.id)}
        />
      ))}
    </Stack>
  );
};

export default OverlayMessagesContainer;
